import { render } from "./MakeQuote.vue?vue&type=template&id=6bfb841b&scoped=true"
import script from "./MakeQuote.vue?vue&type=script&lang=js"
export * from "./MakeQuote.vue?vue&type=script&lang=js"

import "./MakeQuote.vue?vue&type=style&index=0&id=6bfb841b&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfb841b"]])

export default __exports__